import React, { ReactNode } from "react"

import * as styles from "./index.module.scss"

interface CategoryListProps {
  children: ReactNode
  className?: string
}

const CategoryList = ({ children, className }: CategoryListProps) => {
  return <div className={`${styles.list} ${className}`}>{children}</div>
}

export default CategoryList
